import type { FunctionComponent } from 'react';

import { MenuCampaign } from '@/domains/productDiscovery/HeaderLeonidas/components/Menu/components/MenuCampaign/MenuCampaign';
import { BannerCampaign } from '@/productDiscovery/CommercialAnimation/interfaces/bannerCampaign';

interface Props {
  campaigns?: BannerCampaign[];
}

export const MenuCampaigns: FunctionComponent<Props> = ({ campaigns }) => {
  return campaigns && campaigns.length > 0 ? (
    <div
      className="absolute left-[720px] top-[56px] hidden max-h-[calc(100%-56px)]
        gap-m overflow-y-auto px-m pb-m desktop:grid"
    >
      {campaigns.map((campaign, index) => (
        <MenuCampaign campaign={campaign} key={campaign.id} position={index} />
      ))}
    </div>
  ) : null;
};

MenuCampaigns.displayName = 'MenuCampaigns';
